import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "We monitor your network continuously — availability, performance and health — and pair that visibility with a help desk that acts the moment something looks wrong.",
    "Catching issues early prevents small problems becoming outages, and a real help desk means there's always someone to pick up when they do.",
];

const FEATURES = [
    { title: "Continuous monitoring", text: "Availability and performance watched in real time, all day." },
    { title: "Help desk support", text: "A responsive team to act on alerts and user issues quickly." },
    { title: "Early detection", text: "Spot degradation before it becomes downtime." },
    { title: "Clear reporting", text: "Regular insight into network health and trends." },
];

const CHECKS = [
    "Real-time network monitoring",
    "Performance & uptime tracking",
    "Help desk support",
    "Alerting & escalation",
    "Health reporting",
];

export default function NetworkMonitoringOutsourcingServices() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Server & Networking" title="Network Monitoring & NOC Help Desk" eyebrowAs="span">
                    See everything, miss nothing — continuous network monitoring backed by a responsive help desk.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
